import React from "react";
import { useNavigate } from "react-router-dom";
import RightCaretIcon from "../../../Layout/Icons/RightCaretIcon";
import "./ReviewLink.css";

const ReviewLinkButton = ({
  routeId,
  numInvalidElements,
  location,
  areAnyColorsOutOfStock
}) => {
  const navigate = useNavigate();

  // Disable the button if there are invalid elements (outside print area) OR out-of-stock colors
  const isDisabled = numInvalidElements > 0 || areAnyColorsOutOfStock === true;

  const handleClick = (e) => {
    e.preventDefault();
    // Fix the navigation path to match router configuration
    navigate(`/${routeId}/review${location?.search || ""}`);
  };

  return (
    <button
      className={`button button--step-next${isDisabled ? " disabled" : ""}`}
      onClick={handleClick}
      disabled={isDisabled}
    >
      Add To Cart
      <RightCaretIcon />
    </button>
  );
};

export default ReviewLinkButton;
